export class CredentialsDto {
  public username: string | undefined;
  public password: string | undefined;
  public token: string | undefined;

  constructor(init?: Partial<CredentialsDto> | undefined) {
    Object.assign(this, init);
  }
}
